import React, { useEffect } from "react";
import EmailIcon from "@mui/icons-material/Email";
import { Box, Button, FormControlLabel, Switch, Typography } from "@mui/material";
import API from "../../../api2";
import useNotification from "../../../Hooks/useNotification";
import useAdminControlsStore from "../../../Stores/AdminControlsStore";

function UserDialogBoxEdit() {
    const notify = useNotification();
    const { user, setUser } = useAdminControlsStore()

    const handleResendVerification = async () => {
        if (!user || !user.email) {
            return notify('User email is not available.', 'error');
        }
        const result = await API.resendVerificationEmail(user.email);
        notify(result.message, result.error ? 'error' : 'success');
    };

    return (
        <>
            <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={user.active}
                                onChange={(e) => setUser(e.target.name, e.target.checked)}
                                name="active"
                                color="primary"
                            />
                        }
                        label="Active Account"
                    />
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={user.resetPassword}
                                    onChange={(e) => setUser(e.target.name, e.target.checked)}
                                    name="resetPassword"
                                    color="warning"
                                />
                            }
                            label="Reset Password"
                        />
                    </Box>
                    {user.resetPassword && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', ml: 2 }}>
                            User will be prompted to create a new password on next login.
                        </Typography>
                    )}
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Button
                        variant="outlined"
                        startIcon={<EmailIcon />}
                        onClick={handleResendVerification}
                        size="small"
                        disabled={user.emailVerified}
                    >
                        Resend Verification Email
                    </Button>
                    {user.emailVerified && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', ml: 1, mt: 0.5 }}>
                            User is already verified.
                        </Typography>
                    )}
                </Box>
            </Box>
        </>
    );
}

export default UserDialogBoxEdit;